var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 2C2.5 2 21.5 63 86.75 63C152 63 171 2 171 2",
  stroke: "url(#paint0_linear_520_478)",
  strokeWidth: 4,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M86.5 63.4453C21.0564 63.4453 2 2 2 2V71H171V2C171 2 151.944 63.4453 86.5 63.4453Z",
  fill: "url(#paint1_linear_520_478)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_520_478",
  x1: -8,
  y1: -18,
  x2: 171,
  y2: -66,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#10E3A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63464,
  stopColor: "#10E3A4",
  stopOpacity: 0.299313
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10E3A4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_520_478",
  x1: 83.7419,
  y1: -94.7007,
  x2: 86.271,
  y2: 71.5033,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#11E0A2",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#11E0A2",
  stopOpacity: 0
})));

function SvgChartUniv3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 134,
    viewBox: "0 0 173 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartUniv3);
export default __webpack_public_path__ + "static/media/Chart_Univ3.49ab0cf204f8b7e3e632c80650747dcb.svg";
export { ForwardRef as ReactComponent };